import TextareaAutosize from 'react-textarea-autosize';

import { cn } from '@/shadcn/lib/utils';

import { isLockedWidget } from '@/components/forms/utils/links';
import { useDynamicProps } from '@/hooks/useDynamicProps';
import { usePropsSynchronization } from '@/hooks/usePropsSynchronization';
import { TestId } from '@/types/testId';
import type { WidgetWriterProps } from '../widget.type';

type Props = WidgetWriterProps & {
  /** A new props to make it so we can quickly change the value using `dynamicProps`. */
  maxLength?: number;
  /** A new props to make it so we can quickly change the value using `dynamicProps`. */
  minLength?: number;
};

export const TextArea = (rjsfProps: Props) => {
  const props = useDynamicProps(rjsfProps);
  usePropsSynchronization(props, rjsfProps);

  const isLocked = isLockedWidget(props.id, props.formContext?.links);

  const maxLength = props.maxLength || props.schema.maxLength;
  const minLength = props.minLength || props.schema.minLength;
  return (
    <TextareaAutosize
      aria-invalid={props.invalid}
      aria-label={props.label}
      autoFocus={
        props.autofocus ||
        (props.uiSchema?.['ui:autofocus'] as boolean | undefined)
      }
      className={cn(
        'min-h-20 w-full rounded-md border border-input bg-muted px-3 py-2 text-base placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-card disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:bg-accent',
        props.invalid && 'border-destructive focus-visible:ring-destructive/70'
      )}
      data-cy={`textarea-${props.name}`}
      data-testid={TestId.FormWriter.TextArea}
      disabled={props.disabled || isLocked}
      id={props.id}
      maxLength={maxLength}
      minLength={minLength}
      onChange={e => props.onChange(e.target.value)}
      placeholder={props.placeholder || 'Aa'}
      required={props.required}
      value={props.value}
    />
  );
};
